$(document).ready(function(){
    
	(function ($) {
  		var imageW = 1000;
        var imageH = 1000;
        var fitImagestoContainers = false;
        var firstLoad = true;
    
        var imageContainerWidth;
        var imageContainerHeight;
		
        adjustContainers();

        $(window).resize(function () {
         adjustContainers();
         $('.image_container_large .blog_img').removeAttr('style');
         $('.image_container_large .blog_img').css('visibility', 'visible');
         $('.image_container_large .blog_img').each(function(){
           	adjustImageSize($(this), imageContainerHeight);
         });
       });    
       

       function adjustContainers() {    
         
         imageContainerWidth = $('.image_container_large').width();
         imageContainerHeight = ( imageH / imageW) * imageContainerWidth;
         
         var blogInfoContainerH = $('.blog_info').height();
         
         $('.image_container_large').css('height', imageContainerHeight + 'px');
         $('.blog_container').css('min-height', imageContainerHeight + blogInfoContainerH + 'px');

         $('.image_container_large img').removeAttr('style');  

          if(firstLoad) {
              loadImages();
              firstLoad = false;   
           } else {
             adjustImageSize($(this), imageContainerHeight);
           }
         
       };
       
       function loadImages(){
            $('.image_container_large').each(function(){
              var image_container = $(this);
              if(image_container.hasClass('in_load')) {                     
                var main_image = image_container.children('.blog_img');
                main_image.attr('src', main_image.attr('id'));

                main_image.load(function(){

                  adjustImageSize($(this), imageContainerHeight); 

                  

                  image_container.removeClass('in_load');

                  var duration = Math.floor(Math.random()*1000);
                  main_image.css('visibility','visible').hide().fadeIn(duration);
                  image_container.siblings('.blog_info').css('visibility','visible').hide().fadeIn(duration);
                  image_container.parent().css('visibility','visible').hide().fadeIn(duration);
                  
                });
              }
            });           
       }

       function adjustImageSize(image, containerHeight) {
           var imageHeight = $(image).height();
           var imageWidth = $(image).width();
           if(fitImagestoContainers) {
             if(imageHeight > containerHeight) {
               var newW = (imageWidth / imageHeight) * containerHeight;
               $(image).css('width', newW + 'px');
             } 
           } else {
             if(imageHeight < containerHeight) {
                $(image).css('height', containerHeight + 'px');
                $(image).css('width', 'auto');
                var newW = $(image).width();
                $(image).css('left', ((newW - imageContainerWidth) / 2) * -1 + 'px');

              } else {
                $(image).addClass('height_greater');
                $(image).css('top', ((imageHeight - containerHeight) / 2) * -1 + 'px');
              }             
             
             
           }

       }
     
      
})(jQuery);
  
});

